import { ResortImage, ResortImageType, ResortImageFormat} from "../models/presentation.model";
import { ImagePath } from "../shared/core/ovs.core";

export class ImageService{
    
    private _imageRootUrls: Array<ImagePath>;

    public static DUMMY_IMAGE_URL: string = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
    public initialize(imageRootUrls: Array<ImagePath>){
        this._imageRootUrls = imageRootUrls;
    }

    public getImageUrl(image: ResortImage): string
    {
        if (image.imagePath == -1)
            return image.fileName;

        let path: string = this._imageRootUrls.where(i => i.Id === image.imagePath).firstOrDefault().ImagePathRoot;
        
        if (!path.endsWithStr("/"))
            path += "/";

        return path + image.fileName;
    }

    public getImagesByType(images: ResortImage[], types: ResortImageType[]): ResortImage[]
  {
      if (images && images.length > 0 && types && types.length > 0)
      {
          images = images.where(i => types.contains(i.imageType)).toArray();
      }

      if (images.length > 0)
          return images;

      let dummyImages: ResortImage[] = [];
      let image: ResortImage = new ResortImage();
      image.description = "!!!!  DESCRIPTION MISSING  !!!!";
      image.fileName = ImageService.DUMMY_IMAGE_URL;
      image.title = "!!!! TITLE MISSING !!!!";
      image.imagePath = -1;
      image.imageFormat = ResortImageFormat.Image;
      dummyImages.add(image);
      dummyImages.add(image);
      dummyImages.add(image);
      return dummyImages;
  }

  public getImages(images: ResortImage[]): ResortImage[]
  {
      if (images.length > 0)
          return images;

      let dummyImages: ResortImage[] = [];
      let image: ResortImage = new ResortImage();
      image.description = "!!!!  DESCRIPTION MISSING  !!!!";
      image.fileName = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
      image.title = "!!!! TITLE MISSING !!!!";
      image.imagePath = -1;
      image.imageFormat = ResortImageFormat.Image;
      dummyImages.add(image);
      dummyImages.add(image);
      dummyImages.add(image);
      return dummyImages;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/image.service.ts